import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import ConnectItem from './ConnectItem/ConnectItem';
import ConnectWarning from './ConnectWarning/ConnectWarning';
import ORTypography from '../../../../ORTypography/ORTypography';
import CADownloadLinkContainer from './CADownloadLinkContainer';
import CRCAMgmtContainer from './CRCAMgmt/CRCAMgmtContainer';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  connectionString: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
  hosts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  CACertId: PropTypes.string,
};

const defaultProps = {
  CACertId: '',
};

export function UnstyledConnectTab({
  classes,
  connectionString,
  service,
  hosts,
  name,
  id,
  CACertId,
}) {
  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        {/*
         * TODO
         * Create a new component for headerSection, database user select box
         * and connection-string box.
         */}
        <div className={classes.headerSection}>
          <div className={classes.headerText}>
            <ORTypography className={classes.headerTitle} component="h2" variant="h4">
              Certificate Authority (CA) Management
            </ORTypography>
            <ORTypography variant="body2" className={classes.info}>
              To secure your cluster&rsquo;s node communication you need a Certificate Authority
              (CA) in order to verify identity.
            </ORTypography>
          </div>
        </div>
        {/*
        {(service.toLowerCase() === 'cockroachdb' || service.toLowerCase() === 'mongodb') && (
          <CRCAMgmtContainer service={service} instanceId={id} />
        )}
        */}
        <ConnectItem
          key="main"
          instanceId={id}
          title={service}
          description={null}
          connectionString={connectionString}
        />
        {hosts.map((host, index) => {
          const { role, connectionUri } = host;

          if (service.toLowerCase() === role) {
            return null;
          }

          if (!connectionUri) {
            return null;
          }

          if (service.toLowerCase() === 'mongodb') {
            return null;
          }

          return (
            <ConnectItem
              key={index.toString()}
              instanceId={id}
              title={role}
              description={null}
              connectionString={connectionUri}
            />
          );
        })}
      </div>

      {service.toLowerCase() === 'mongodb' && (
        <ConnectWarning>
          <ORTypography variant="altSubheading">
            Download the Certificate Authority (CA) File for your Instance.
          </ORTypography>
          <ORTypography variant="caption">
            <p>
              You must download the CA Bundle and point to it with the --sslCAFile parameter on your
              Mongo client in order to securely connect with SSL.
            </p>
            <p>
              If you’re using client certificate authentication, more in-depth information can be
              found in our{' '}
              <a
                href="https://docs.api.objectrocket.cloud/#mongodb-certificates-instructions"
                target="_blank"
                rel="noopener noreferrer"
              >
                API Docs
              </a>
              .
            </p>
          </ORTypography>
          <div className={classes.caContainer}>
            <CRCAMgmtContainer service={service} instanceId={id} showCADownloadButton />
          </div>
        </ConnectWarning>
      )}

      {service.toLowerCase() === 'cockroachdb' && (
        <ConnectWarning>
          <ORTypography variant="altSubheading">
            Download the Certificate Authority (CA) File for your Instance.
          </ORTypography>
          <ORTypography variant="caption">
            <p>
              You must download the CA Bundle In order to use higher `sslmode` settings, like
              `verify-ca`
            </p>
            <p>
              If you’re using client certificate authentication, more in-depth information can be
              found in our{' '}
              <a
                href="https://docs.api.objectrocket.cloud/#cockroachdb-certificates-instructions"
                target="_blank"
                rel="noopener noreferrer"
              >
                API Docs
              </a>
              .
            </p>
          </ORTypography>
          <div className={classes.caContainer}>
            <CRCAMgmtContainer service={service} instanceId={id} showCADownloadButton />
          </div>
        </ConnectWarning>
      )}

      {['postgresql', 'timescaledb'].indexOf(service.toLowerCase()) !== -1 && (
        <ConnectWarning>
          <ORTypography variant="caption">
            <p>
              <b>Download the Certificate Authority (CA) File for your instance</b>
            </p>
            <p>
              In order to use higher `sslmode` settings, like `verify-ca`, you will need the CA
              certificate.
            </p>
            <p>
              <CADownloadLinkContainer
                service={service}
                instanceId={id}
                filename={`${name}_CA`}
                CACertId={CACertId}
              />
            </p>
          </ORTypography>
        </ConnectWarning>
      )}
    </React.Fragment>
  );
}

UnstyledConnectTab.propTypes = propTypes;
UnstyledConnectTab.defaultProps = defaultProps;

const styles = (theme) => ({
  pageContainer: {
    backgroundColor: theme.customColors.white,
    border: `1px solid ${theme.customColors.lightGrey}`,
    paddingBottom: theme.spacing(1),
  },
  headerSection: {
    padding: `0 ${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`,
    borderBottom: `1px solid ${theme.customColors.black}`,
    display: 'block',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  caContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  warningContainer: {
    width: '100%',
  },
});

export default withStyles(styles)(UnstyledConnectTab);
